module.exports = __webpack_public_path__ + "media/newstyle/images/a5-white-6b9da625740d2694e8fac0f296b0e525.svg";